import React from 'react';
import { connect, Provider } from 'react-redux';
import ab from 'react-redux-hydra';

import UnleashFlagProvider from 'containers/UnleashFlagProvider';
import { AppState } from 'types/app';
import { EnvironmentConfigState } from 'types/environment';
import { store as reduxStore } from 'entrypoints/bootstrapOnClient';
import MartyContextProvider from 'containers/MartyContextProvider';
import { AlertRoot, LogRoot, StatusRoot } from 'components/common/AriaLive';
import Themer from 'tailwind/components/Themer/Themer';
import marketplace from 'cfg/marketplace.json';
import MartyThemeProvider from 'styled/containers/MartyThemeProvider/MartyThemeProvider';
import MartyThemeProviderProps from 'styled/containers/MartyThemeProvider/MartyThemeProvider.types';

interface RootProps {
  children: React.ReactNode;
  environmentConfig: EnvironmentConfigState;
  history: object;
  store: typeof reduxStore;
}

const Root = (props: RootProps) => {
  const { children, environmentConfig, history, store } = props;

  const {
    api: { unleash }
  } = environmentConfig;

  return (
    <>
      <Provider key={Math.random()} store={store}>
        <UnleashFlagProvider config={unleash}>
          <Themer />
          <MartyContextProvider history={history} environmentConfig={environmentConfig}>
            <MartyThemeProvider currentTheme={marketplace.theme as MartyThemeProviderProps['currentTheme']}>{children}</MartyThemeProvider>
          </MartyContextProvider>
        </UnleashFlagProvider>
      </Provider>
      <AlertRoot />
      <StatusRoot />
      <LogRoot />
    </>
  );
};

const mapStateToProps = (state: AppState) => ({
  features: state.features
});

export default connect(mapStateToProps, { forceAssignment: ab?.actions?.forceAssignment })(Root);
